var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.49982 13.0783C1.33982 13.0783 1.17979 13.0175 1.05813 12.895C0.813958 12.6508 0.813958 12.2549 1.05813 12.0108L6.44977 6.61912L1.05813 1.22748C0.813958 0.983311 0.813958 0.587448 1.05813 0.343281C1.30229 0.0991146 1.69815 0.0991146 1.94232 0.343281L7.77565 6.17661C8.01982 6.42078 8.01982 6.81664 7.77565 7.06081L1.94232 12.8941C1.81982 13.0175 1.65982 13.0783 1.49982 13.0783Z",
    fill: "#FCFCFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.c3187e1f4491312f47dd3d65331d383b.svg";
export { ForwardRef as ReactComponent };